import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { interval, Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { StartPostTemporary } from 'src/app/auth/store';
import { AppState, getMyAuth } from 'src/app/store/app.state';

@Component({
  selector: 'app-note-personali',
  templateUrl: './note-personali.component.html',
  styleUrls: ['./note-personali.component.css']
})
export class NotePersonaliComponent implements OnInit {
  @Output() close = new EventEmitter<void>();
  @Input() note: string;
  loggedUserId: number;
  autosave: Subscription;
  
  constructor(private store: Store<AppState>) { }

  ngOnInit(): void {
    this.store.select(getMyAuth).pipe(take(1)).subscribe(d => {
      this.loggedUserId = d.loggedUser.id;
    });
  }
  
  ngAfterViewInit() {
    this.autosave = interval(10000).subscribe(() => {
      if(document.querySelector('.fate-edit-target').innerHTML !== this.note) {
        this.store.dispatch(new StartPostTemporary({idUtente: this.loggedUserId, newNote: document.querySelector('.fate-edit-target').innerHTML}))
      }
    });
  }

  onClose() {
    this.autosave.unsubscribe();
    this.close.emit();
  }

  onSaveContent(event) {
    if(this.note !== event) {
      this.store.dispatch(new StartPostTemporary({idUtente: this.loggedUserId, newNote: event}));
    }
    this.onClose();
  }
}
